module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("CHAPTER 2")])]), _c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_c('p', {
    staticClass: "orna"
  }, [_c('img', {
    attrs: {
      "alt": "The Crusader States",
      "src": "images/ornament.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_vm._v("Syria and Palestine")])]), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p26"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("‘S")]), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("O")]), _vm._v(" at last our knights came into the valley where stands the royal city of Antioch, capital of Syria, which was granted to blessed Peter, prince of the Apostles, to restore to the holy faith, by Our Lord Jesus who liveth and reigneth with God the Father in the unity of the Holy Ghost, One God, world without end.’"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-1",
      "id": "nr2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" With these words the author of the "), _c('i', [_vm._v("Gesta Francorum")]), _vm._v(" describes the emergence of the crusader army from the Amanus mountains into the Orontes valley in mid-October 1097. There is a palpable sense of relief in the text at this point since, for the past month, the crusaders had been struggling over the Anti-Taurus range through Coxon and Marash, sometimes along mountain paths so narrow that they had been obliged to adopt single file. Even then, horses had fallen over precipices and baggage animals, roped together, had pulled one another over the edge. Many knights were so ‘frightened and miserable’, the author says, that they had thrown away their armour rather than carry it.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("They secured the so-called Iron Bridge over the Orontes on 19 October and, within two days, they were arrayed before Antioch. The debate that followed – whether to make an immediate assault or settle down for a long siege – must have reflected their mixed feelings at what they saw around them. Antioch was attractively situated. According to the "), _c('i', [_vm._v("Gesta")]), _vm._v(", there were ‘plenty of provisions, fruitful vineyards and pits full of stored corn, apple-trees laden with fruit and all sorts of other good things to eat’. Ralph of Caen, who did not take part in the First Crusade, but had direct experience of Antioch during the later years of Tancred's rule until the latter's death at the end of 1112, describes how nearby Daphne supported Bohemond. Daphne, he says, means delightful and had been so named by the Greeks. It held ‘a position of glory among the other valleys, having an abundance of fruits, vines, trees and water’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-2",
      "id": "nr2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Half a century before, Ibn Butlan, a Christian Arab physician from "), _c('a', {
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("Baghdad, had travelled from Aleppo to Antioch through a populous and productive countryside in which ‘the villages ran continuous, their gardens full of flowers, and the waters flowing on every hand’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-3",
      "id": "nr2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Yet to an attacker, the city was daunting. Although the population was much diminished from its height under the later Roman empire, Ibn Butlan thought Antioch immense. Set out in a semicircle on the left bank of the Orontes, protected by a double line of walls and, he claims, 360 towers, it backed onto Mount Silpius, near the summit of which was the citadel, and the Iron Gate, approachable only by means of a narrow defile. The mountain overshadowed the city so that the sun only began to shine about the second hour of the day."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-4",
      "id": "nr2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Ralph of Caen explained that the plain on which Antioch lay was, in fact, constrained between two mountains to the north and the south-south-west, and that the mountains grew broader farther east."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-5",
      "id": "nr2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Raymond of Aguilers was so in awe of its situation that he claimed that neither the impact of machines nor the assault of men would have any effect, ‘even if all mankind gathered to besiege it’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-6",
      "id": "nr2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Moreover, although the crusaders had arrived in the autumn when grain and fruit were abundant, they were only days away from the rainy winter season, which began in November and lasted until March or April."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-7",
      "id": "nr2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Indeed, the crusaders were fortunate not to experience the exceptional conditions recorded by Michael the Syrian in the autumn of 1172. In September, the rain and the snow arrived much earlier and more suddenly than usual, ruining the harvest. ‘It destroyed the vines, the olive trees, the cotton and the sesame, which looked like black charcoal, as if they had been burned by fire. This calamity made itself felt not only in Assyria, in Mesopotamia and Syria, but also in the countries of Persia and Armenia, and even in Palestine and Egypt. The whole land resembled a heap of wood shavings which the fire had devoured and which had become burnt and powdered.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-8",
      "id": "nr2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Ralph of Caen knew what a Syrian winter could be like. During the siege of Antioch, ‘there were floods of water, sometimes in sudden downpours, and sometimes in continuous streams. There was great movement of both the heaven and earth so that it appeared that the two elements had been joined together with the one rising up and the other coming down. But what about the storms, what shall I say about the raging of the winds? While they were blowing, neither tent nor hut could stand. Indeed, it was hardly possible for the palace and the tower to survive.’ The weather was no respecter of persons; in Ralph's view, the nobility felt it more than the peasants because the former were ‘accustomed to luxury’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-9",
      "id": "nr2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Stephen of Blois certainly thought so. In his letter to Adela on 29 March 1098, he told her that ‘all winter long … we suffered extremely cold temperatures and an endless downpour of rain for Christ the Lord. When some people "), _c('a', {
    attrs: {
      "id": "p28"
    }
  }, [_vm._v("say that the heat of the sun throughout Syria is unbearable, this is wrong, since their winters are similar to our western winters.’"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-10",
      "id": "nr2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" However, Stephen did not stay to experience a Syrian summer. In August, Godfrey of Bouillon left for the mountains, where he stayed in Ravendel and Turbessel. Albert of Aachen says that, having seen Bishop Adhémar succumb to disease on 1 August, he feared ‘that this was the same illness which he had remembered had afflicted Rome long ago with a very similar disaster when he was on an expedition with King Henry IV’. At that time it had killed 500 in the army and had led the Germans to abandon Rome."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-11",
      "id": "nr2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" If it was the same disease, it was almost certainly malaria, endemic in the swamps around Rome, but the crusaders were afflicted by dysentery as well, common in the East whenever sanitary conditions were poor. Ralph of Caen calls it a ‘vile illness’, and Ibn al-Qalanisi says it was ‘a disease to be feared and one from which its victim scarcely ever recovers’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-12",
      "id": "nr2-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The experiences of the crusaders at Antioch in 1097–8 were in many ways a reflection of the broader physical environment. In c.985, Muhammed al-Muqaddasi, a theologian and merchant born in Jerusalem, wrote a description of Syria in which he divided the country into four belts. The first bordered the Mediterranean, which he calls ‘the plain-country, the sandy tracts following one another, and alternating with the cultivated land’. The second was ‘the mountain-country, well wooded, and possessing many springs, with frequent villages, and cultivated fields’. The third belt ‘is that of the valleys of Ghaur, wherein are found many villages and streams, also palm trees, well cultivated fields, and indigo plantations’. Finally, there were the lands along the edge of the desert. ‘The mountains here are high and bleak, and the climate resembles that of the Waste; but it has many villages, with springs of water, and forest trees.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-13",
      "id": "nr2-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The coastal plain varied considerably in width and fertility, depending on the proximity of the mountains to the sea. Thus, in what became the county of Tripoli, the main cultivable area was the wedge of the ‘Akkar plain, formed by the Kebir River and its tributaries and the volcanic soils of al-Buqai'ah farther east towards the mountains. However, to the north and south around Maraclea and Gibelet respectively, the littoral is much narrower."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-14",
      "id": "nr2-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Even so, relatively small areas could be productive. William of Tyre was especially proud of the hinterland of his own city. ‘It was famous for its unique beauty of location and the fertility of its soil. Although lying in the sea itself, entirely surrounded by waves like an island, yet it had before its gates extensive arable fields, excellent in every respect, while a level plain of rich and productive soil stretched out from the city itself and furnished the people of Tyre with abundant supplies.’ This terrain was only about 10 miles long and between 2 and 3 miles wide, but ‘its exceeding fertility makes it equal to acres of boundless extent’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-15",
      "id": "nr2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "p29"
    }
  }, [_c('img', {
    attrs: {
      "alt": "The Crusader States",
      "src": "images/map4.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p29"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "p29"
    }
  }), _c('a', {
    attrs: {
      "id": "map4"
    }
  })]), _c('a', {
    attrs: {
      "id": "map4"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "map4"
    }
  }), _c('a', {
    attrs: {
      "id": "p30"
    }
  }, [_vm._v("Inland were several formidable mountain ranges, mostly limestone and basalt. The Anti-Taurus, which the crusaders endured, projects south from the Armenian plateau into Syria, and from there are the shorter and narrower ranges of the Amanus, north of Antioch, and the Nosairi (Ansariyah) and the Lebanon, to the south. The Nosairi mountains average 1,000 metres in height, which is enough for snow in winter (see plate 2). The Orontes flows north along the eastern side of the Nosairi through Homs, Hama and Shaizar before turning west past Antioch and reaching the sea at Saint Simeon. The Lebanese mountains are even higher, averaging nearer 2,000 metres. Further south still is the Anti-Lebanon range, separated from the Lebanese mountains by the depression of the Beqa valley. The Litani River flows south and west from here, reaching the coast north of Tyre. Accessible routes across these mountains were obviously key strategic points. South of the Nosairi mountains al-Buqai'ah offers a passage; not surprisingly, this region always contained the highest number of fortresses in the county of Tripoli."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-16",
      "id": "nr2-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In Palestine the coast is backed by hills rather than mountains on this scale, most importantly the Judaean hills south and east of Jerusalem. Pilgrims wishing to bathe in the Jordan were obliged to cross this arid region, a land of nomads and hermits, unable to support large permanent communities. As the crusaders attacking Jerusalem found, there was little timber for constructing siege engines. When Tancred did find some wood in a cave while seeking somewhere private to relieve the effects of his dysentery, it was regarded as a miracle of God."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-17",
      "id": "nr2-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" There was still a striking deficiency when Theoderic, a German monk, probably from the well-wooded Rhine valley, visited Jerusalem seventy years later. ‘Wood there, whether for carpentry or for firewood, is expensive, since Mount Libanus, which is the only place which has much timber, cedars, cypresses and fir trees, is not only far away from the city, but also no one can go there on account of the ambushes by the Gentiles.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-18",
      "id": "nr2-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" However, even the Syrian woodland had been greatly reduced by the demands placed upon it in antiquity and the early middle ages, so that it had become isolated from the larger forests of the Amanus to the north. According to an anonymous visitor to the kingdom of Jerusalem who wrote a treatise describing the Holy Land and its peoples around 1170, Mount Lebanon ‘has very tall cedars, but these are not as abundant as they were in former times’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-19",
      "id": "nr2-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Farther east are the Syrian steppe lands within which lay the great Islamic cities of Damascus and Aleppo. As Ibn Butlan describes it, much of this land was under cultivation, especially near sources of water such as the Orontes."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-20",
      "id": "nr2-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" The only Latin state established beyond these regions was that created by "), _c('a', {
    attrs: {
      "id": "p31"
    }
  }, [_vm._v("Baldwin of Boulogne at Edessa (Urfa), about 160 miles to the north-east of Antioch in Upper Mesopotamia. This was really an extension of the steppe lands, rising in a series of ridges towards the Euphrates. Edessa itself is farther still, situated about 45 miles east of the river. Nevertheless, despite the distance, it had its attractions. ‘This city,’ says Fulcher of Chartres, who accompanied Baldwin, ‘is very famous and is in a most fertile area.’"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-21",
      "id": "nr2-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" However, according to the Armenian chronicler Matthew of Edessa, it did not always realise its potential, for it was sometimes subject to sudden changes in its weather patterns. In 1099–1100, there was an acute drought, causing the land to become dessicated and thus leading to a severe famine. Fortunately, the rain returned the following year, so there was an abundance of the main products of the region, which included wheat, barley, fruit and grapes."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-22",
      "id": "nr2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("To the south is the great rift valley, which encompassed the Jordan. This flowed into the Sea of Galilee (Tiberias) and then on to the Dead Sea. Between the Sea of Galilee and Mount Carmel, overlooking Haifa on the coast, is the Galilean plain which, like parts of the Syrian steppe, offered good agricultural land. Just to the south-west of the lake stood the extraordinary Mount Tabor, much visited by pilgrims, who believed it was the site of the Transfiguration (see plate 3). Abbot Daniel of Kiev, who visited the kingdom of Jerusalem between 1106 and 1108, says that it took six hours of steady climbing to reach the top. ‘Mount Tabor is a marvel and wonder and is beyond description, made beautiful by God. … It is situated in a beautiful plain far from other mountains like a round haycock and a river flows through the plain at its foot. And Mount Tabor is covered all over with trees of every kind, figs and carobs and olives in great abundance.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-23",
      "id": "nr2-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In November and December 1100, Baldwin of Boulogne, the new ruler of Jerusalem, set out to explore the south and south-east. As his chaplain, Fulcher was again with him. Fulcher was fascinated by the wonders of the natural world. ‘There is there a great lake which is called the Dead Sea because no living thing is born in it. It extends five hundred and eighty stades in length and one hundred and fifty in width. It is so salty that no beast or bird of any kind whatsoever can drink from it. This, I, Fulcher, learned by experience when I dismounted from my mule into the water and took a drink with my hand, testing it by the taste and finding it to be more bitter than hellebore.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-24",
      "id": "nr2-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" A few years later, Abbot Daniel was similarly amazed.")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("And there are high rocky mountains here with many caves in those mountains, and holy fathers lived in these mountains in this fearful waterless wilderness. Here are the lairs of the panther and there are many wild asses. The Sea of Sodom is dead and has no living thing in it, neither fish nor crayfish, nor shellfish, and if the "), _c('a', {
    attrs: {
      "id": "p32"
    }
  }, [_vm._v("swift current of the Jordan should carry a fish into this sea, it cannot live even an hour but quickly dies. And from the depths of this sea red pitch rises to the surface and this pitch lies on the shore in great quantity and a stench comes up from this sea as if from burning sulphur."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-25",
      "id": "nr2-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Penetrating farther south, Baldwin, Fulcher and his party reached Wadi Musa (west of Petra), which impressed them because of the fertility of the valley and because they identified it as the place where Moses had struck the rock to bring forth a spring. Above was the mountain where Moses and Aaron spoke with God (Numbers 20). They rested here for three days before returning to Jerusalem on the day of the winter solstice (21 December)."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-26",
      "id": "nr2-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Fulcher seems never to have travelled beyond this but, in 1116, Baldwin took a force of 200 knights down to the Red Sea ‘that he might see what he had not yet seen and along the way fortuitously find something good which he wanted’, a journey of about seven days via his new castle of Montréal (Shaubak). This meant crossing the desert lands of the Negev and Sinai, or the Waste, as al-Muqaddasi called it, before reaching Ailah (al-'Aqabah)."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-27",
      "id": "nr2-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("As the armies at Antioch soon came to realise, this terrain encompassed wide variations in precipitation and temperature. Around Antioch itself the average annual precipitation is about 46 inches (1,181 mm), most of which falls during the winter, leaving long, hot, dry summers, with little in the way of spring or autumn. Although the average annual temperature is between 15 and 20"), _c('sup', [_vm._v("ˆ")]), _vm._v("C, this conceals much greater extremes. In the mountains the midwinter temperature can fall below freezing, while in the plain summer levels can rise above 30"), _c('sup', [_vm._v("ˆ")]), _vm._v("C."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-28",
      "id": "nr2-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Once the crusaders left Antioch and, urged on by popular pressure, began to push south towards Jerusalem, they found that precipitation decreased as the temperature climbed: in what became the kingdom of Jerusalem, average temperatures of around 20–22"), _c('sup', [_vm._v("ˆ")]), _vm._v("C could be transformed by the desert winds of early summer into highs of 40"), _c('sup', [_vm._v("ˆ")]), _vm._v("C or more. In 1185, John Phocas, a Greek pilgrim from Crete, visited the Holy Land, where he had a particular interest in Orthodox monasteries and their sites. Among these was the monastery of Choziba, near the Jericho road. ‘Indeed the recesses of the caves are the monks’ cells. And the Church itself and the cemetery are set in the chasm of the rock, and everything is so blasted by the burning sun that one can see the rock emitting tongues of flame like pyramids. In fact the water which the monks drink is of the kind which comes from a pool, when the midsummer sun hangs above the pools and heats it to boiling-point with its fiery rays.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-29",
      "id": "nr2-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Rainfall in Palestine, again almost exclusively in the winter, is less than half that in Antioch, diminishing to almost nothing in the hills and deserts of the "), _c('a', {
    attrs: {
      "id": "p33"
    }
  }, [_vm._v("east and south. In al-Muqaddasi's time, in the late tenth century, water was plentiful in Jerusalem, but it was entirely because of the city's conservation measures, which included the provision of three great tanks, twenty underground cisterns in the Haram area and two pools in the Muristan."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-30",
      "id": "nr2-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" The natural condition of the region was one of aridity. It was ‘entirely lacking in water,’ says William of Tyre, with no springs or rivers, and therefore depended upon the winter rains to replenish the cisterns."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-31",
      "id": "nr2-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Even so, there are still micro-climates: Tiberias and the borders of the lake experience very mild winters of around 14"), _c('sup', [_vm._v("ˆ")]), _vm._v("C. Indeed, al-Muqaddasi places this area within his third belt, characterised by palms, cultivated fields and indigo plantations."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-32",
      "id": "nr2-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The pressures experienced by the crusaders in northern Syria could all too easily be repeated elsewhere. Raymond of Aguilers is one of several writers to describe how starvation gripped the crusaders’ camp during the winter of 1097–8, a situation exacerbated on the kalends of January (1 January 1098), when there was a frightening earth tremor."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-33",
      "id": "nr2-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" The twelfth century was a particularly active period for earthquakes in this region, culminating in May 1202, when, according to Philip of Plessis, master of the Temple, ‘we suffered the sort of earthquakes not seen since the creation of the world’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-34",
      "id": "nr2-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" In the twenty years between 1097 and 1117, Fulcher of Chartres recorded six separate earthquakes, including the most serious in 1114, which, although the epicentre appears to have been at Marash, which was destroyed, was strong enough to damage buildings in Antioch, 60 miles to the south."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-35",
      "id": "nr2-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Equal in severity to that of 1202 was the Syrian earthquake of 29 June 1170, which brought down the cathedral of St Peter in Antioch, as well as the walls of the city, and ruined many of the great castles of the military orders in the county of Tripoli. Muslim cities were similarly struck, especially Aleppo, Hama, Homs and Baalbek. Tremors were felt as far south as Jerusalem and as far north and east as the Jacobite monastery of Mar Hanania, near Mardin, over 100 miles east of Edessa. Aftershocks continued for three to four months."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-36",
      "id": "nr2-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The earthquakes of August and November 1114 had been preceded in the spring by locusts, which, says Walter, the chancellor of Antioch between c.1114 and c.1122, ‘stole nearly all the things necessary to feed the farmers of Syria. Then they were dispersed partly by crawling along the ground, partly through the air, and they afflicted almost the whole region of the eastern Christians to the same devastating effect.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-37",
      "id": "nr2-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" It was not only crops that were vulnerable. Ambroise, the Norman poet who took part in the Third Crusade, describes the afflictions of King Richard's army in August 1191. Encamped south of Haifa, they were disturbed during the night by an ‘attack from stinging worms and tarantulas which harassed them greatly, stinging the pilgrims who would at once swell up’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-38",
      "id": "nr2-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("While earthquakes were prevalent in the north, crossing the desert lands south of the kingdom of Jerusalem presented its own hazards. In 1167, Shirkuh, one of the most important generals of Nur al-Din, ruler of Aleppo and Damascus, was caught in a terrible sandstorm while trying to lead an army into Egypt. William of Tyre witnessed such phenomena for himself.")])]), _c('a', {
    attrs: {
      "id": "p34"
    }
  }), _c('div', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "p34"
    }
  }), _c('p', {
    staticClass: "fext"
  }, [_c('a', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("Particles of sand raised aloft swirled through the air like clouds or dense fog. The men dared not open their mouths to speak to one another, nor could they keep their eyes open. Dismounting from their horses, they lay prostrate clinging to the ground, their hands pressed into the sand as far as possible, lest they be swept aloft by the violence of the whirlwind and again dashed to the ground. For in that desert waves of sand like those of the sea are wont to rise and fall as in a tempest, a fact that renders the crossing of these perilous reaches not less dangerous than sailing over the sea."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-39",
      "id": "nr2-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The crusaders were well aware that they could do nothing to change the basic facts of topography and climate, and usually attributed natural disasters to God's will, a scourging inflicted as punishment for riotous living and plundering, as Raymond of Aguilers put it."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-40",
      "id": "nr2-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" However, human geography presented both different problems and new opportunities, for this was a populous and diverse land, dominated by ancient cities and ports, inhabited by many races, and deeply marked by the impact of three great religions and their offshoots. A web of communications followed the coast, crossed the mountain passes and the inland valleys, and spread out across the plains and the desert."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-41",
      "id": "nr2-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The remains of the past confronted them at every turn."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-42",
      "id": "nr2-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Latakia was an important port, but it had seen better days. Ralph of Caen, describing Tancred's siege of 1101–2, was very impressed.")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("It could be seen from the ruins that this city had once been noble, having churches, a large population, riches, towers, palaces, theatres and all of the other things which make a place great. Aside from Antioch, no other city had within its circuit such great signs of ancient nobility. The multiple series of columns, aqueducts which ran over rough terrain, towers built toward the heavens, statues lying around in fitting places, all of which were well constructed from precious materials. All of these noteworthy works, still present after so much time and so many ravages, provide evidence of its past from its present, its former state from its destroyed remains, and its large population from its current state of abandonment."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-43",
      "id": "nr2-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p35"
    }
  }, [_vm._v("In 1121, pursuing the Muslims across the Jordan, King Baldwin II destroyed a fortress built the previous year by Tughtigin, atabeg of Damascus, within the ruins of the second-century Roman city of Jerash (see plate 4). Fulcher of Chartres describes it as ‘marvellously and gloriously founded upon a strong site in ancient times’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-44",
      "id": "nr2-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" Similar sights could be found at Sidon and Gibelet or Jubail (the Greek Byblos), and even in the thirteenth century the past continued to impinge. When the Templars began to dig the foundations of their great new castle at ‘Atlit, on a promontory south of Haifa, in 1217 and 1218, they uncovered ancient walls and found coinage of a type quite unknown to contemporaries."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-45",
      "id": "nr2-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" There were equally impressive remains in the south. When, in 1149–50, Baldwin III sought to rebuild Gaza, on the coast below Ascalon, he encountered a site too large for him to fortify in its entirety. It had been, says William of Tyre, one of the five cities of the Philistines. ‘It was celebrated for its buildings, and many handsome churches and spacious houses of marble and huge stones, though now in ruins, still gave splendid evidence of its ancient glory. Many reservoirs and wells of living water also still remained.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-46",
      "id": "nr2-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("At Tyre, Archbishop William set down this historical context. At the beginning of book 13 of his chronicle, he describes what he considers to be the most important characteristics of the place he designates ‘the metropolis of all Phoenicia’. According to Justinian's great law code, the "), _c('i', [_vm._v("Digest")]), _vm._v(", published in 533, Tyre held a special legal position within the Roman empire, having been granted ‘Italian rights’ as a reward for its loyalty. Its origins, however, were much earlier. Drawing on his knowledge of Solinus and Ovid, William claims that it had belonged to King Agenor and his children, Europa, Cadmus and Phoenix, from the last of whom, ‘as the Phoenicians claim, that the whole region derives its name’. Initially it had had two names: Sor, which was Hebrew; and Tyre, Greek in origin, from its foundation by Tyrus, the seventh son of Japhet, the son of Noah. It was already famous ‘in early times’, as can be seen from Old Testament references in Ezekiel and Isaiah, the stories told of the relations between Hiram, king of Tyre, and Solomon in the "), _c('i', [_vm._v("Antiquities")]), _vm._v(" of Josephus, the first-century "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" Jewish historian, and the account of the great faith of the Canaanite woman from the city given in chapter 15 of Matthew and prophesied in Psalm 45. As presented by the archbishop, therefore, Tyre can be seen as a model of the renowned cities of the region: founded in legend, integrated into biblical history, and an established political and economic entity in the Hebrew, Greek and Roman worlds."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-47",
      "id": "nr2-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("William calls this region ‘Syria’. It is, he says, a name used ‘sometimes in a broad sense as applying to the whole province, and again in a more limited way to designate only a part of the same’. Greater Syria extended from the Tigris to Egypt and from Cilicia to the Red Sea. It was divided into twelve "), _c('a', {
    attrs: {
      "id": "p36"
    }
  }, [_vm._v("provinces: Mesopotamia, lying between the Tigris and the Euphrates; Coelesyria, which includes Antioch; the two Cilicias; Phoenicia, now divided between Phoenicia Maritima, the metropolis of which is Tyre, and Phoenicia Libania, the capital of which is Damascus; the two Arabias, centred on Bostrum and Petra respectively; the three Palestines, Jerusalem, capital of Judea, maritime Caesarea and Scythopolis, also called Bethsan (Baisan); and, finally, the last province, Idumea, extending towards Egypt.")])]), _c('a', {
    attrs: {
      "id": "p36"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p36"
    }
  }, [_vm._v("While there was nobody on the First Crusade with William's education and access to books, nevertheless the participants had answered Urban's call because at one level or another they understood the meaning of what the pope had described as ‘our lands’, that is, they adhered to the distinctly Latin Christian interpretation of the region's history. They knew, too, however, that they were not entering a land of neat administrative divisions, but one soaked in the blood of past conflicts to an extent unparalleled in the known world. The geopolitics of the Middle East had determined that Syria was a frontier region across which powers whose epicentres were far to the west or the east fought out their many wars. In the late tenth century, al-Muqaddasi praised Syria as a place of glorious renown, but nevertheless presented its inhabitants as victims of outsiders, corrupted by the circumstances that trapped them. ‘But the people live ever in terror of the Byzantines, almost as though they were in a land of exile, for their frontiers are continuously ravaged, and their fortresses again and again destroyed. Nor are the Syrians the equals of the Persians in either science, religion or intelligence; some have become apostates, while others pay tribute to the infidels, thus setting obedience to created man before obedience to the Lord of Heaven. The populace, too, is ignorant and seditious, and the Syrian people show neither zeal for the Holy War, nor honour to those who fight against the infidel.’"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-48",
      "id": "nr2-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("These conflicts had deep roots. Persian expansion into Asia Minor in the fifth century "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(" led to clashes with the Greeks; the ultimate response was the invasion of Alexander of Macedon who, in 337 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(", eliminated the Archaemenid rulers of Persia. After Alexander's death in 323 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(", his empire was carved up by his generals. One of them, Seleucus, established Seleucia Pieria in Cilicia and founded, among other cities, Antioch, Apamea and Latakia. Antioch became a key centre both because of its strategic and commercial position and because it was consciously created as a Hellenistic centre within an oriental setting. With Roman expansion into the region in the first century "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(", it developed into a prosperous city, particularly favoured by Augustus (27 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v("–"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 14)."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-49",
      "id": "nr2-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Persia, however, remained a threat, and Armenia, Syria and Palestine were integrated into a Roman defensive system that lasted in various forms until the Muslim conquests of the seventh century.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p37"
    }
  }, [_vm._v("Muhammad's revelations transformed this world. Until the early seventh century, the framework of the ancient order had survived. The Byzantines, secure in their great capital of Constantinople on the Bosphorus, maintained that they were the true heirs of the Romans, despite the collapse of the empire in the West in the fourth and fifth centuries. They continued to see other mighty powers as their main rivals, most obviously the Persians, based at Ctesiphon on the Tigris. When these two giants clashed they took little account of the other peoples of the Middle East. But Muhammad had appeared at an opportune moment. Worn down by the coruscating wars of the first three decades of the seventh century, neither the Byzantines nor the Persians were ready to face a new and unforeseen challenge. During the 620s, Muhammad overcame political and military opponents in the Arabian peninsula and convinced a large proportion of the population that he was, as he had claimed, the prophet chosen by God as the vehicle for the final revelation. After his death in 632, his successors, driven by what had become a dynamic new religion, committed themselves to an unprecedented territorial expansion. Antioch, which Emperor Heraclius had won back from the Persians in 628 and thereafter used as his eastern base, succumbed soon after the main Byzantine army was defeated at Yarmuk in 636. Heraclius retreated to Constantinople, never to return.")])]), _c('a', {
    attrs: {
      "id": "p37"
    }
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("Within a century, the Muslims had encompassed Syria, Palestine and Egypt, the entire southern shore of the Mediterranean, and most of the Iberian peninsula. Significantly, these new conquests included the city of Jerusalem, taken in 637, and seen as the third great religious centre of the Islamic world after Mecca and Medina. The Byzantine empire was deeply wounded and later twice had to fight off determined attempts to take Constantinople itself, but at least it survived; for the old Persian empire, the rise of Islam was fatal. Westward expansion was matched by eastern conquests, initiated by the defeat of the Persians at al-Qadisiyah in 637. When the last shah was killed by his own men in 651, the way was open to central Asia. Historians have long been divided about the nature of the impact of Islam upon the medieval West, sometimes arriving at diametrically opposite conclusions about the economic and political effects of the division of the great inland sea the Romans had seen as their own. It is, though, indisputable that the creation and expansion of this new religious force were both a threat and a challenge to a world that, since the late fourth century, had been dominated by Christianity, and the long-term effects were as profound as the replacement of Greece by Rome and Rome by the Germans.")])]), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p37"
    }
  }, [_vm._v("The crusaders, therefore, represented yet another outside invader of a region long fought over by Greeks, Persians, Romans, Byzantines and Arabs, ")]), _c('a', {
    attrs: {
      "id": "p38"
    }
  }, [_vm._v("all of whom had left their cultural imprint. They were not there, however, to admire the remnants of Antioch's agora or its great colonnaded street; they had come, in the pope's mind at least, to rescue their co-believers from Turkish oppression and to liberate the holy places from the control of the infidel. For them, the most important feature of Antioch's history was its formative role in the establishment of Christianity as a distinct religion after the martyrdom of Stephen in Jerusalem in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 34 or 36. As the author of the "), _c('i', [_vm._v("Gesta")]), _vm._v(" saw it, Antioch was the city of ‘the blessed Peter, prince of the Apostles’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-50",
      "id": "nr2-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" For the crusaders, Peter's presence there in the middle of the first century meant that he was the first bishop of the Church, a view reinforced by contemporary papal thinking which, basing itself on the Gospel of Matthew (16: 18), believed to have been written there, stressed the importance of the see of St Peter as the rock upon which the Church was founded."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-51",
      "id": "nr2-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" William of Tyre saw it as fundamental to the adoption of Christianity. ‘In this city the first gathering of the faithful was held and here also the name of Christians was adopted. Before this time, those who followed the teachings of Christ were called Nazarenes. Afterwards, by authority of that synod, all the faithful were known as Christians, a name derived from that of Christ. This city voluntarily and eagerly received the preaching of the apostle and was converted as one body to the Christian faith. She was the first to embrace and to teach the Name which, like a precious anointment, diffuses its fragrance far and wide.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-52",
      "id": "nr2-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("While both religious feeling and strategic necessity made it inconceivable that the crusaders would ignore Antioch, their ultimate goal was Jerusalem, ‘the Holy City beloved of God’, as William of Tyre described it. In William's history, the most salient points were its foundation by David (which took place in c.1000 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v("), its prophesied destruction by the Romans (in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 70), and its rebuilding on top of the hill by Hadrian (in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 135 as Aelia Capitolina), when its new walls encompassed the sites of the Passion and the Resurrection."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-53",
      "id": "nr2-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" As William's emphasis shows, it was its association with the events of the Crucifixion and as the place from which the Apostles began their mission that mattered most to the crusaders."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-54",
      "id": "nr2-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" Like the other cities of the region, it had been subject to a whole succession of invaders, including the Babylonians in the sixth century "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(" and the Greeks and the successors of Alexander. Although the Maccabean revolt of 168 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(" inspired a Jewish revival, in 63 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(" Jerusalem was conquered by Pompey and thereafter ruled by Rome, albeit sometimes through client kings such as Herod the Great (37–34 "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v("). It only became important in the Christian Church as a whole after the penetration of Christianity into imperial circles under Constantine, particularly after Helena, Constantine's mother, visited the city in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 326. Even then it did not become one of the great patriarchates of the Church until 451."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-55",
      "id": "nr2-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" It is not surprising that, during the twelfth century, the ecclesiastical rivalry between Antioch and Jerusalem remained acute.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "p39"
    }
  }, [_c('img', {
    attrs: {
      "alt": "The Crusader States",
      "src": "images/map5.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p39"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "p39"
    }
  }), _c('a', {
    attrs: {
      "id": "map5"
    }
  })]), _c('a', {
    attrs: {
      "id": "map5"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "map5"
    }
  }), _c('a', {
    attrs: {
      "id": "p40"
    }
  }, [_vm._v("All the major accounts of Urban II's speech at Clermont stress the pope's call to help their persecuted eastern brethren, accompanied by more or less lurid descriptions of what the Turks were doing to them. Baldric, prior and then abbot of Saint-Pierre-de-Bourgueil (west of Tours in the Loire region), before his promotion to the archbishopric of Dol in 1107, who was present at Clermont, wrote in c.1108 that the pope had spoken of the ‘dreadful tribulations’ of the Christians, who are ‘scourged, oppressed and injured in Jerusalem and Antioch and other cities along the eastern coastline’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-56",
      "id": "nr2-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")]), _vm._v(" However, while these brethren may indeed all have been ‘our brothers, members of Christ's body’, in practice they were made up of a heterogeneous collection of different Churches and races. The great earthquake of 1114 in Antioch, acknowledged Walter the Chancellor, affected ‘Latins, Greeks, Syrians, Armenians, strangers and pilgrims’,"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-57",
      "id": "nr2-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" while the pilgrim John of Würzburg, visiting Jerusalem in c.1165, felt unable to give an account of the ‘people of every race and tongue’ he found there, ranging as they did, he claimed, from Greeks to Indians."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-58",
      "id": "nr2-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("By ‘Greeks’ the crusaders meant members of the Orthodox Church, adhering to the tenets of the faith as set down at the council of Chalcedon in 451. After the fall of Jerusalem to the Arabs in 638, these were called Melkites; some spoke Greek and used it as their liturgical language, but others spoke Arabic and used Syriac as their liturgical language, a distinction largely based on education and class."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-59",
      "id": "nr2-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Under Muslim rule these communities had followed their own liturgies and retained their traditional legal forms, and they continued to do this even after the crusader conquest, despite a diminution in the numbers of patriarchal clergy in Jerusalem. Moreover, although after 1099 a Latin hierarchy replaced them, so that the Greek patriarchs of Jerusalem spent most of their time in exile, the powerful monastic tradition that they represented still commanded respect, providing a continuous link to the anchorites and early monastic communities, which went back to the third century."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-60",
      "id": "nr2-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" The Orthodox were present throughout the crusader lands, in all the coastal cities, in the major centres like Antioch, Edessa and Jerusalem, and in smaller communities in places like the south-eastern Transjordan or in the scattered monasteries sought out by John Phocas in the 1180s (see plate 5).")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "p41"
    }
  }, [_c('img', {
    attrs: {
      "alt": "The Crusader States",
      "src": "images/map6.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p41"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "p41"
    }
  }), _c('a', {
    attrs: {
      "id": "map6"
    }
  })]), _c('a', {
    attrs: {
      "id": "map6"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "map6"
    }
  }, [_vm._v("In his list, John of Würzburg includes Armenians, Jacobites, Maronites, Copts and Nestorians, all of whom were seen as heretical by the Greeks, who had persecuted them in the past. At best, they were seen as schismatic by the Latins, since they were not in communion with Rome. It is not clear if the crusaders thought they had come to save these from the Turks as well, although Michael the Syrian says that, during the expedition, the Franks had ")]), _c('a', {
    attrs: {
      "id": "p42"
    }
  }, [_vm._v("promised God that, if he allowed them to enter Jerusalem, they would live in peace with all Christian confessions and would give each of them churches and convents."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-61",
      "id": "nr2-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" Nevertheless, following the death of Adhémar of Le Puy in August 1098, the secular leaders of the crusade informed the pope that they had driven out the Turks and pagans, but were unable to expel those whom they called the heretics, by which they meant the Greeks, Armenians, Syrians and Jacobites."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-62",
      "id": "nr2-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" This hostility may have derived in part from the inability of the Latins to distinguish the different elements in the local population. William of Tyre says that, during the siege of Antioch, there were many spies in the camp, who could move easily among the troops since ‘some pretended to be Greeks, some Syrians, and other Armenians, and all could easily assume the characteristics of such nations in idioms, manners, and dress’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-63",
      "id": "nr2-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" Nonetheless, it soon became evident that accommodation with the local Christians was possible in a way never achieved by the Byzantines, as links developed through marriage and military co-operation, and William says that nearly all the inhabitants of Antioch were ‘true believers’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-64",
      "id": "nr2-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The Armenians and the Jacobites were the most numerous, although they were found mostly in the northern crusader states rather than in the kingdom of Jerusalem."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-65",
      "id": "nr2-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" Armenia can be broadly defined as the lands between the Caucasus to the north and the Taurus mountains to the south, with the Black Sea to the west and the Caspian to the east. Like Syria, Armenia had had the misfortune to be a zone of conflict between the great powers; the Byzantines in particular saw it as an area of great strategic importance. The Armenians claimed apostolic origin for their Church, but they were actually converted in the early fourth century by St Gregory the Illuminator, ‘the Apostle of Armenia’ (c.240–332). They did not adhere to the Chalcedonian creed; indeed, they may not even have known about the council at the time it was held. They were therefore not trusted by the Byzantines, who saw them as monophysite heretics, although the Armenians denied this. Whatever the truth of this, they had been victims of both the Byzantine policy of dispersal and the more recent Seljuk expansion, which explains why the crusaders encountered them in Cilicia (which became known as Lesser Armenia), northern Syria and around Edessa."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-66",
      "id": "nr2-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" As a consequence, there was, says the anonymous author of the treatise on the Holy Land, ‘an implacable hatred’ between the Greeks and the Armenians."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-67",
      "id": "nr2-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Armenian unwillingness to accept the Chalcedonian definitions may well have had more to do with fear of Byzantine domination than with doctrine. However, the Jacobites were quite distinctly monophysite in that they believed the Incarnate Christ to be of one nature only, rejecting the doctrine set down at Chalcedon of two natures, divine and human, mystically united, while the "), _c('a', {
    attrs: {
      "id": "p43"
    }
  }, [_vm._v("Maronites were monotheletes, accepting that Christ had two natures, but only one (Divine) will."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-68",
      "id": "nr2-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(" The Jacobites were named after Jacob Baradaeus, who became metropolitan of Edessa in c.542, during a career of consistent opposition to the Byzantines. As the Syrian Orthodox Church, they had communities in all the crusader states, but were particularly strong in northern Syria, under the leadership of their own patriarch of Antioch."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-69",
      "id": "nr2-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Although there were fewer of them in the south, nevertheless they had a continuous line of metropolitans in Jerusalem in the twelfth century, among whom was Ignatius Hesnun (who died in 1124 or 1125), who rebuilt the church of St Mary Magdalene and Simon the Pharisee, situated in the north-east corner of the city, which had been virtually deserted at the end of the eleventh century."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-70",
      "id": "nr2-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The Maronites had originally been based at Antioch, but when the crusaders arrived they were mainly to be found in the northern Lebanese mountains, where they had taken refuge from Byzantine persecution. They were less dispersed than the Armenians and the Jacobites; William of Tyre estimated that there were about 40,000 of them living in the region of Gibelet. Their heresy was, he says, ‘that in our Lord Jesus Christ there exists, and did exist from the beginning, one will and one energy only’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-71",
      "id": "nr2-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" This seems to be a reference to the doctrine of monotheletism, which Heraclius had tried to introduce in an unsuccessful attempt to reconcile dissident Churches in the midst of the Persian crisis of the 620s. They took their name from St Maro (350–433), who founded a monastery on the Orontes not far from Apamea in the late fourth century, although their monophysite beliefs were most likely to have been derived from another Maro, Maro of Edessa, who lived in the late sixth century."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-72",
      "id": "nr2-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The Copts and the Nestorians were less important to the crusaders, although, as John of Würzburg shows, they clearly had a presence in the kingdom of Jerusalem. The Copts, in fact, might have become of much greater interest to the Latins had King Amalric succeeded in gaining control of northern Egypt during the 1160s, since their main centre was Alexandria. Coptic tradition claimed unbroken succession from St Mark, martyred in Alexandria in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 68. Their opposition to Chalcedon was therefore less a doctrinal matter – they did not deny the two natures of Christ – than one of authority."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-73",
      "id": "nr2-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" The Nestorians were different from the other four eastern Christian Churches in that they believed in two separate natures in Christ Incarnate, although it is not clear that Nestorius, the patriarch of Constantinople after whom they were named, actually taught this himself. Nestorius had certainly been a controversial figure, having been made patriarch in 428, only to be deposed in 431 and exiled to Upper Egypt five years later. Whatever the"), _c('a', {
    attrs: {
      "id": "p44"
    }
  }, [_vm._v(" truth of this dispute the Nestorians had been very successful in the early middle ages, spreading east through Persia, so that by c.1000 they had at least twenty metropolitan dioceses."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-74",
      "id": "nr2-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("One other group of Christians included in John of Würzburg's list was the Georgians, whose monastery and church of the Holy Cross stood about a mile to the south-west of Jerusalem. It was a special place, as it was believed to encompass the stump of the tree from which the wood of the Cross was made."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-75",
      "id": "nr2-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" The Georgians had been converted by the mid-fourth century and accepted the Chalcedonian tenets; as monks, hermits and pilgrims, they had had a presence in and around Jerusalem since at least the fifth century. Although it had been damaged in the eleventh century, Abbot Daniel mentions that the monastery was functioning at the time of his visit, and there was also a convent of Georgian nuns, one of whom, the former wife of King David (1089–1125), had probably founded the house at about this time."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-76",
      "id": "nr2-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" The Georgians had considerable military strength: in 1120, Ansell, cantor of the Holy Sepulchre, described the kingdom as ‘a rampart for us against the Medes and Persians’, and, after the Latin defeat in 1187, they were strong enough to insist that Saladin restore their losses in Jerusalem as a consequence of the war."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-77",
      "id": "nr2-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" However, the core of their power between the Black Sea and the Caspian Sea was too far north to have much direct effect upon the crusader states. Even so, after 1187, Queen Tamar (1184–1213) took the opportunity to assume the role of protector of the Christians in the East on the basis that both the Latins and the Greeks had failed in this task."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-78",
      "id": "nr2-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The crusaders, of course, believed that Syria and Palestine were ‘the lands of the Christians’. This was not the way the Jews saw it. For them, ever since the Diaspora, as early as the eighth century "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(", the land of Israel had been in the hands of invaders. The famous thirteenth-century Jewish scholar from Gerona known as Nahmanides (Moses ben Nahman) (d. c.1270) wrote a commentary on Leviticus 26:32, ‘I will destroy your land and the enemies who occupy it will be appalled.’ Conceived in the light of events in the East in the twelfth and early thirteenth centuries, it took this form: ‘And these are good tidings proclaiming in all the lands of the Diaspora that our land does not accept our foes. And this is a decisive proof and a great promise, because you will hardly find in all the inhabited world a country which is so fair and spacious, settled from time immemorial, and which is as much ruined as this one. For ever since we departed from it, it has not accepted a single other nation or language. They all try to settle it, but it is beyond their power.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-79",
      "id": "nr2-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The capture of Jerusalem by the crusaders in July 1099 was yet another of these enemy blows. Jews who had remained in the city suffered badly in the massacre, but not all of them were killed, since Tancred would not otherwise "), _c('a', {
    attrs: {
      "id": "p45"
    }
  }, [_vm._v("have been able to ransom some of them after the crusader frenzy had died down."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-80",
      "id": "nr2-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")]), _vm._v(" Jewish leaders in Cairo were aware of the situation and sent representatives to Ascalon with funds to pay ransoms, a practice that continued until 1102."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-81",
      "id": "nr2-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" After this, Jews were not allowed to remain in Jerusalem, but they continued to live in some of the crusader cities such as Tiberias and in the larger Galilean villages, where they were within walking distance of the synagogues."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-82",
      "id": "nr2-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" In fact, by c.1170, limited settlement had again been permitted in Jerusalem, for the Jewish traveller Benjamin of Tudela, who meticulously recorded the Jewish communities scattered around the Mediterranean and the Middle East, said that a small group of about 200 lived ‘under the Tower of David in one corner of the city’, where they specialised in dyeing, over which they had been given a monopoly by the king in return for a small rent."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-83",
      "id": "nr2-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("However, even before Jerusalem fell, Tancred and Eustace of Boulogne had made a raid on Nablus, 32 miles to the north. There, they found not only local Christians, but also a substantial community of Samaritans, perhaps as many as 1,000 people. There were probably another 500 living in Acre, Caesarea, Ascalon and Gaza."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-84",
      "id": "nr2-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" The Samaritans were a separate Jewish group, who based their religious rites upon a version of the Pentateuch and centred their worship on their temple on Mount Gerizim. They had been excluded from the main body of the Jews since the time of the Babylonian exile in the sixth century "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BC")]), _vm._v(", in which they had no part, and since the time of the Muslim invasions had been Arabic-speaking, although continuing to pray in Hebrew.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The Arabs had swept into this complicated world of different peoples and beliefs in the 630s. Muhammad believed that he was the unworthy instrument of God's final revelation and thus the ultimate successor of the Jewish prophets, including Christ. Islam imposed a strict monotheism and moral code, which entailed a series of obligations, most importantly, as Ibn Shaddad, Saladin's qadi of the army, expressed it, ‘testimony that there is no god but God, performance of the prayers, the giving of alms, fasting in Ramad"), _c('img', {
    attrs: {
      "alt": "The Crusader States",
      "src": "images/amacr.jpg"
    }
  }), _vm._v("n, and the Pilgrimage to the Sacred House of God’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-85",
      "id": "nr2-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" This had been set down in the 114 "), _c('i', [_vm._v("suras")]), _vm._v(" (chapters) of the Koran, later supplemented by the "), _c('i', [_vm._v("Hadith")]), _vm._v(", or sayings of the Prophet. After Mecca, the place of pilgrimage, and Medina, which had sheltered Muhammad during his exile from Mecca, Jerusalem was the third of the great holy cities. Here the Archangel Gabriel had taken Muhammad to the rock from which the Prophet ascended through the seven heavens to receive Divine revelation. When Saladin besieged Jerusalem in early October 1187, there followed, claimed Ibn al-Athir, ‘the fiercest fight that anyone had ever seen, as each side of the two sides believed that it was a religious task and a binding duty’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-86",
      "id": "nr2-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p46"
    }
  }, [_vm._v("However, when Muhammad had died in 632, Islam was a faith that was still evolving, with only a fraction of the adherents and territory it was to gain over the next two centuries. Inevitably, as it expanded, it was modified by circumstances: the Islamic world of the crusader era was not one dominated by the desert tribes of Arabia, but by military and intellectual leaders whose bases were urban mosques and madrasas, and who followed a literature that had not been consolidated until the ninth century."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-87",
      "id": "nr2-87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")]), _vm._v(" Not surprisingly, under the pressure of such development, Islam had splintered. If they had not been fully cognisant of it before, the crusaders at Antioch were soon aware that the Muslims were far from unified in their faith, for, in February 1098 envoys representing the Fatimid caliph at Cairo presented themselves at the crusader camp. According to Albert of Aachen, they not only offered them the city of Jerusalem, which they had recently retaken from the Turks, but also urged them to continue their attack on Antioch. ‘There had been,’ he says, ‘very severe discord and hatred between [the caliph] and the Turks long before this expedition of the Christians.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-88",
      "id": "nr2-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("This hatred was based on more than cultural and racial antagonisms, for the Fatimid caliphate had been established in 969 as the chief Shi'ite power within Islam, thus consolidating a long-standing schism that found its origins in the generation that followed Muhammad's death. William of Tyre, who wrote a history of the Muslim world, describes how Muhammad's successors, beginning with Abu-Bakr (who had been one of his earliest associates), had ruled as caliphs, ‘because they succeeded their famous master and were his heirs’. They were, however, challenged by Ali, a cousin of Muhammad, who ‘considered it unfitting that he should be called the successor of his cousin and not rather a great prophet himself’. Not everybody accepted this, but there were some who believed him, ‘so a schism developed among that people which has lasted even to the present. Some maintain that Muhammad is the greater and, in fact, the greatest of all prophets, and these are called in their own tongue, Sunnites; others declare that Ali alone is the prophet of God, and they are called Shiites.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-89",
      "id": "nr2-89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" William's presentation of the schism as a rivalry between two prophets was not entirely accurate in that Ali claimed to be the first true successor of Muhammad rather than his rival; nevertheless, it is clear that the Latins soon grasped that this represented a fundamental fissure within Islam, which, although political in origin, had over time developed religious dimensions as well."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-90",
      "id": "nr2-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("From 750, the Sunni had been represented by the Abbasids, the second of whom built a new city at Baghdad, near the former Persian capital of Ctesiphon. The Abbasid dynasty achieved great longevity, lasting until 1258, when they were exterminated by the Mongols. However, from the mid-tenth "), _c('a', {
    attrs: {
      "id": "p47"
    }
  }, [_vm._v("century, they were largely in the hands of a new element in Islam, the Seljuk Turks; in 1055, the reigning caliph had installed Tughril Beg as sultan or temporal ruler, and from this time the Turks represented the cutting edge of the Sunnite cause. The first crusaders were much impressed by the Seljuks, even when describing their atrocities. Survivors of the crusade of 1101 told Albert of Aachen that they were ‘wicked and dreadful men, whose heads were shaved in front and behind, on right and left sides in the manner of a neck, and whose sparse hairs hanging down from these four necks bristled as an uncut crest, with also untrimmed and flowing beards, and who are reported to resemble in their appearance nothing so much as ugly and filthy spirits’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-91",
      "id": "nr2-91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")]), _vm._v(" In a powerful passage, the author of the "), _c('i', [_vm._v("Gesta")]), _vm._v(", the battle of Dorylaeum fresh in his mind, wrote: ‘What man, however experienced and learned, would dare to write of the skill and prowess and courage of the Turks, who thought that they would strike terror into the Franks, as they had done into the Arabs and Saracens, Armenians, Syrians and Greeks, by the menace of their arrows?’ He claimed they had a saying that they were of common stock with the Franks and, he says regretfully, if only they adhered to the true faith ‘you could not find stronger or braver or more skilful soldiers’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-92",
      "id": "nr2-92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("However, by the later twelfth century the Franks had become aware of another Muslim enemy, the Kurds, seen as equally formidable. Their homelands were in southern and eastern Anatolia and north-eastern Iraq but, not surprisingly, since Saladin was a Kurd, they played a prominent part in his armies. According to an anonymous Christian survey of the forces gathered by Saladin during the battles for the control of Acre between 1189 and 1191, the Kurds were the best knights and were characterised by the greatest nobility. ‘They serve all the Saracen princes as soldiers, just like the English and Danes in Constantinople.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-93",
      "id": "nr2-93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The Shi'ites, for their part, asserted that they represented the only legitimate line of imams, by which they meant those who were divinely guided in their exposition of the true faith, and from these there would appear the Mahdi or Guided One. There was much disagreement over who this would be and when this event would occur, but for the crusaders the most significant element was the Fatimids at Cairo, who adhered to an imam called Ismail, who died sometime before 765. His successor had appeared in 909 and his descendants established themselves at Cairo sixty years later. There was evidently a powerful messianic element among the Shi'ites, which itself was always likely to provoke further splits. In 1090, one such group of dissidents set themselves up at Alamut in Persia and adopted political murder as their preferred method of operation. These became known as the Assassins, and their western branch, established in the 1130s in enclaves in the Nosairi "), _c('a', {
    attrs: {
      "id": "p48"
    }
  }, [_vm._v("mountains, became very well known to the Latins, although they were to be found farther east around the Jabal as-Summaq at the time of the First Crusade."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-94",
      "id": "nr2-94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")]), _vm._v(" According to William of Tyre, in the 1170s they numbered around 60,000 and possessed ten fortresses together with adjacent villages."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-95",
      "id": "nr2-95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The majority of indigenous Muslims living in the lands conquered by the crusaders were to be found in the south. The main Muslim villages were in Samaria and eastern Galilee, while the Franks settled in the area north of Jerusalem as far as Sanjil (Saint-Gilles), that is, in the places already inhabited by eastern Christians. There was, therefore, a distinct Muslim region, determined by cultural rather than ecological frontiers, and already established centuries before the arrival of the crusaders."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-96",
      "id": "nr2-96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" These must have been the people described by the German pilgrim Theoderic in the early 1170s around Nablus. ‘When we were going along this road we saw a crowd of Saracens, who were all beginning to plough with their oxen and asses a very well-kept field. And they uttered a horrid cry, which is not unusual for them when they start any work, but they filled us with great terror! There are a great number of pagans there, who stay everywhere in cities and villages and farms of this province.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-97",
      "id": "nr2-97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Many Muslims were nomadic or engaged in some form of transhumance. In his description of the origins of the Turkish race, William of Tyre explains that, initially, all the Turks were nomadic, ‘constantly roaming around here and there in search of the best pasture for their flocks’, but that thirty to forty years before the arrival of the crusaders they had established much more stable political entities in Persia. Even so, there continued to exist those whom he calls Turcomans, who ‘still retained their rude and primitive mode of life’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-98",
      "id": "nr2-98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" Michael the Syrian describes how in the winter the Turcomans were accustomed to migrate from the north into southern Syria, where there was no snow or frost and where they could find pasture, returning in the spring. In 1185, they were attacked en route by a band of Kurds intent on stealing their animals, an incident that escalated into a large-scale conflict that left many dead."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-99",
      "id": "nr2-99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" The Bedouin Arabs were similarly nomadic, living mostly along the outer edges of the crusader lands in the Transjordan and the Sinai and Negev deserts. Raids upon the Jewish and Muslim settlements in eastern Galilee were not uncommon, but often quite unconnected to the wider war between the Muslims and the Franks."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-100",
      "id": "nr2-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" Nor were the nomads always the predators. In February 1157, King Baldwin III attacked Arabs and Turcomans grazing their flocks and herds in the woodlands near Banyas. These people, says William of Tyre, ‘live in tents and are accustomed to support life from the products of animals’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-101",
      "id": "nr2-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("When they crossed the Iron Bridge over the Orontes in October 1097, the crusaders were entering an ancient land, just one more invading army over "), _c('a', {
    attrs: {
      "id": "p49"
    }
  }, [_vm._v("the centuries. As Fulcher of Chartres was soon to discover, it was an environment that would change them far more than they could ever have imagined. In the course of spending thirty years in the East, Fulcher became imbued with a strong sense of the need for co-existence, reflected not only in his empathy with the Greeks, Syrians and Armenians, but even with the Muslims."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en2-102",
      "id": "nr2-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")]), _vm._v(" A generation after the crusade, in the mid-1120s, he reflected on this. ‘Indeed it is written,’ he said, quoting Isaiah, “The lion and the ox shall eat straw together”.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en2-103",
      "id": "nr2-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b36a6c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/0112_Syria_and_Palestine.vue
// module id = 84
// module chunks = 0